import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api_url } from "../config/config";

const AddStore = () => {
  const navigate = useNavigate();
  const [branchName, setBranchName] = useState("");
  const [address, setAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [location, setLocation] = useState("");

  const handleSaveChanges = async (e) => {
    e.preventDefault();

    // Validate pincode (optional: assuming 6-digit Indian pincode)
    if (pincode && !/^\d{6}$/.test(pincode)) {
      alert("Please enter a valid 6-digit pincode.");
      return;
    }

    // Validate mobile number
    if (contactNumber && !/^\d{10}$/.test(contactNumber)) {
      alert("Please enter a valid 10-digit contact number.");
      return;
    }

    const payload = {
      area: branchName,
      branch_address: address,
      pincode: Number(pincode),
      contact_number: contactNumber,
      location: location,
    };

    try {
      const response = await fetch(`${api_url}/branch`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const result = await response.json();
        alert("Store successfully created!");
        console.log("API Response:", result);
        navigate("/ng-admin/branches");
      } else {
        const error = await response.json();
        console.error("API Error:", error);
        alert(error.message || "Failed to create store.");
      }
    } catch (error) {
      console.error("Network Error:", error);
      alert("An error occurred while submitting the form. Please try again.");
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h2 className="text-2xl font-semibold mb-3">Add Store</h2>

      <div className="max-w-6xl mx-auto bg-white shadow-lg rounded-lg p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <div className="mb-6">
              <h2 className="text-lg font-semibold mb-4">Store Information</h2>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Store / Branch Name
                </label>
                <input
                  type="text"
                  className="w-full border border-gray-300 rounded-lg p-3"
                  placeholder="Enter Store Name"
                  value={branchName}
                  onChange={(e) => setBranchName(e.target.value)}
                  required
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Address
                </label>
                <textarea
                  className="w-full border border-gray-300 rounded-lg p-3"
                  placeholder="Enter Store Address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  required
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Pincode
                </label>
                <input
                  type="text"
                  maxLength="6"
                  className="w-full border border-gray-300 rounded-lg p-3"
                  placeholder="Enter Pincode"
                  value={pincode}
                  onChange={(e) => setPincode(e.target.value)}
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Contact Number
                </label>
                <input
                  type="text"
                  maxLength="10"
                  className="w-full border border-gray-300 rounded-lg p-3"
                  placeholder="Enter Contact Number"
                  value={contactNumber}
                  onChange={(e) => setContactNumber(e.target.value)}
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Google Maps Location
                </label>
                <input
                  type="text"
                  className="w-full border border-gray-300 rounded-lg p-3"
                  placeholder="Enter Location "
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                />
              </div>

              <button
                className="bg-[#3C1F1F] p-2 px-6 rounded-lg text-white"
                onClick={handleSaveChanges}
              >
                Save Store
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddStore;
